import React from 'react';
import { FaShieldAlt, FaPercent, FaStethoscope, FaPhoneAlt } from 'react-icons/fa';
import { TiArrowUpOutline } from "react-icons/ti";

const logoWhite = process.env.PUBLIC_URL + '/HWS_WebSupport_Res.MulticareLogotype_White.png';

function Footer() {
  return (
    <footer className="bg-[#181A1A] relative">

      {/* ===== FOOTER TOP: Logo + Heading + CTA ===== */}
      <section className="pt-16 lg:pt-20 pb-12">
        <div className="max-w-[1046px] mx-auto px-6 text-center">
          <img src={logoWhite} alt="Multicare" className="h-[36px] lg:h-[48px] mx-auto mb-8" />
          <h2 className="text-white text-[2.25rem] md:text-[2.875rem] lg:text-[3.5rem] font-bold leading-tight">
            A sa&uacute;de vem sempre em 1&ordm; lugar
          </h2>
          <p className="text-[#C2C5C5] text-base lg:text-lg mt-4 max-w-[600px] mx-auto leading-relaxed">
            Conhe&ccedil;a todas as coberturas e servi&ccedil;os que est&atilde;o &agrave; sua disposi&ccedil;&atilde;o.
          </p>
          <div className="mt-8">
            <button
              className="inline-flex items-center gap-2 bg-[#FEC800] hover:bg-[#EFAB00] text-[#282A2A] font-bold py-4 px-8 rounded-2xl text-lg transition-all duration-300 hover:-translate-y-1"
              onClick={() => document.getElementById('askproposal')?.scrollIntoView({ behavior: 'smooth' })}
            >
              <TiArrowUpOutline size={22} />
              Pedir simula&ccedil;&atilde;o de seguro
            </button>
          </div>
        </div>
      </section>

      {/* ===== TRUST SECTION ===== */}
      <section className="pb-16 lg:pb-20">
        <div className="max-w-[1046px] mx-auto px-6">

          {/* Label + Title */}
          <div className="flex flex-col items-center mb-12">
            <span className="text-[#FAFAFA] text-sm md:text-base uppercase font-medium inline-flex relative pb-[3px] mb-4
              before:absolute before:bottom-0 before:w-full before:h-[4px] before:bg-[#FEC800] before:rounded-[100px]">
              Ser cliente Multicare
            </span>
            <h3 className="text-white text-2xl md:text-[2.875rem] lg:text-[3.5rem] font-bold text-center leading-tight">
              Raz&otilde;es para confiar nos Seguros de Sa&uacute;de da Multicare
            </h3>
            <p className="text-[#C2C5C5] text-base lg:text-lg mt-4 text-center max-w-[600px]">
              Estamos dispon&iacute;veis para esclarecer qualquer d&uacute;vida e dar o apoio necess&aacute;rio.
            </p>
          </div>

          {/* Trust Cards - style matching official accordion items */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
            {[
              { icon: <FaShieldAlt size={28} />, bold: 'Marca l\u00EDder', text: ' em Seguros de Sa\u00FAde' },
              { icon: <FaPercent size={28} />, bold: 'At\u00E9 15% desconto', text: ' sobre o pr\u00E9mio comercial para proteger toda a fam\u00EDlia' },
              { icon: <FaStethoscope size={28} />, bold: 'Programa de rastreios anual e personalizado', text: ' sem custos adicionais' },
              { icon: <FaPhoneAlt size={28} />, bold: 'Acesso a m\u00E9dicos', text: ' por telefone sem custos adicionais' },
            ].map((card, i) => (
              <div key={i} className="bg-[#2D2E2E]/90 rounded-[20px] p-5 md:p-6 flex flex-col items-center text-center gap-4 group transition-all duration-300 hover:bg-[#3A3C3C]">
                <div className="text-[#FEC800] transition-transform duration-300 group-hover:scale-110">
                  {card.icon}
                </div>
                <p className="text-[#C2C5C5] text-sm lg:text-[15px] leading-relaxed font-normal">
                  <b className="text-[#FEC800] font-semibold">{card.bold}</b>{card.text}
                </p>
              </div>
            ))}
          </div>

        </div>
      </section>

      {/* ===== FOOTER LEGAL INFO ===== */}
      <section className="bg-[#161717] py-10 px-6">
        <div className="max-w-[1046px] mx-auto">

          {/* Logo + Legal text */}
          <div className="flex flex-col md:flex-row items-start gap-6">
            <div className="flex-shrink-0 mx-auto md:mx-0">
              <img src={logoWhite} alt="Multicare" className="h-[24px] opacity-50" />
            </div>
            <div className="text-[#656769] text-xs leading-relaxed text-center md:text-left">
              <p>
                * Pr&eacute;mio total para fracionamento mensal, aplic&aacute;vel durante a 1&ordf; anuidade, para uma pessoa de 30 anos que subscreva o seguro Multicare 1.
                <br />Campanha v&aacute;lida para subscri&ccedil;&atilde;o de um seguro de sa&uacute;de Multicare at&eacute; 31 de dezembro 2026.
                <br />Esta informa&ccedil;&atilde;o n&atilde;o dispensa a consulta da informa&ccedil;&atilde;o pr&eacute;-contratual e contratual legalmente exigida.
              </p>
              <p className="mt-4">
                Fidelidade - Companhia de Seguros, S.A.- NIPC e Matr&iacute;cula 500 918 880, na CRC Lisboa - Sede: Largo do Calhariz, 30 1249-001 Lisboa &ndash; Portugal - Capital Social EUR 509.263.524
                <br />
                Apoio ao Cliente: Dias &uacute;teis das 9h &agrave;s 20h. Assist&ecirc;ncia: todos os dias 24h/dia - T. 217 948 880 Chamada para a rede fixa nacional.
                {' '}E. <a href="mailto:apoiocliente@multicare.pt" className="text-[#EFAB00] hover:underline">apoiocliente@multicare.pt</a>
                {' '}. <a href="https://www.multicare.pt" target="_blank" rel="noopener noreferrer" className="text-[#EFAB00] hover:underline">www.multicare.pt</a>
              </p>
            </div>
          </div>

          {/* Bottom bar - copyright + links */}
          <div className="mt-8 pt-6 border-t border-[#282A2A] flex flex-col md:flex-row items-center justify-between gap-4">
            <span className="text-[#656769] text-xs">
              Copyright &copy; 2026 Multicare. Todos os direitos reservados.
            </span>
            <div className="flex flex-wrap gap-4 text-xs">
              <a href="https://www.multicare.pt" target="_blank" rel="noopener noreferrer" className="text-[#A1A4A4] hover:text-[#FEC800] transition-colors">
                Condi&ccedil;&otilde;es Gerais de Utiliza&ccedil;&atilde;o
              </a>
              <a href="https://www.fidelidade.pt/PT/protecao-dados/Documents/Politica_de_Privacidade_e_Protecao_de_Dados_Pessoais%E2%80%93FIDELIDADE.pdf" target="_blank" rel="noopener noreferrer" className="text-[#A1A4A4] hover:text-[#FEC800] transition-colors">
                Pol&iacute;tica de Privacidade
              </a>
              <a href="https://www.multicare.pt" target="_blank" rel="noopener noreferrer" className="text-[#A1A4A4] hover:text-[#FEC800] transition-colors">
                Pol&iacute;tica de Cookies
              </a>
            </div>
          </div>

        </div>
      </section>

    </footer>
  );
}

export default Footer;
